export default __webpack_public_path__ + "static/media/DAIF_Infra_Screen1-end.219ddce9.jpg";